// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__1VbN9","header":"About_header__MElry","goBack":"About_goBack__Gljql","container":"About_container__NZGpb"};